import React from 'react';
import { IconContext } from "react-icons";
import { FiUser } from "react-icons/fi";
import { Trans } from 'react-i18next';

const Header = ( props ) => {
  return (
    <div className="header">
      <div className="title"> <Trans>Profile</Trans> </div>
      <div className="separator"> | </div>
      <div className="icon">
        <IconContext.Provider size={ 25 } value={{ color: "rgb(45,45,60)", className: "global-class-name" }}>
          <div>
            <FiUser />
          </div>
        </IconContext.Provider>
     </div>
    </div>
  )
}

export default Header
